import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import './data_styles/datamiddle.css';

export default function DataMiddle() {
  return (
    <>
      <Container className='mt-3 mb-3 data_middle'>
        <Row>
          <Col className='d-flex flex-column justify-content-center align-items-center dt_mid'>
            <h3>DATA(100)</h3>
            <p>Get a quick overview of the latest events in the crypto industry around the world</p>
          </Col>
        </Row>
      </Container>
    </>
  )
}
